import React, {useState} from 'react';
import {useParams} from 'react-router-dom';

import {useBulkActionDialog} from 'src/components/bulk-tool/useBulkActionDialog';

import {Dialog} from '@pb/kit-component-dialog-v2';

import {GROUP_TABS} from '../constants';

import {EditGroupModal} from './edit-group.modal';

import type {GroupSelect} from '../typedef';

type Props = {
    selectedGroup: GroupSelect | null,
    onClose: (submit?: boolean) => void,
    onDelete: () => void,
};

export const EditGroupDialog = ({selectedGroup, onClose, onDelete}: Props) => {
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : -1;
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const {onClose: closeDialog, onPendingChange} = useBulkActionDialog(() => onClose(false));

    return (
        <Dialog
            shown={!!selectedGroup}
            setShown={closeDialog}
            wrapperProps={{style: {width: showDeleteConfirmation ? 550 : 877}}}>
            <EditGroupModal
                groupId={selectedGroup?.groupId || 0}
                selectedTab={selectedGroup?.view || GROUP_TABS.SETTINGS.name}
                accountId={accountId}
                onCloseModal={submit => submit ? onClose(true) : closeDialog()}
                onPendingChange={onPendingChange}
                onDelete={onDelete}
                showDeleteConfirmation={showDeleteConfirmation}
                setShowDeleteConfirmation={setShowDeleteConfirmation}
            />
        </Dialog>
    );
};
